export default "__VITE_ASSET__DJ6Spfx5__"